import React, { useMemo } from 'react';

import { OrderContext } from 'context';
import { SciPage } from 'enums';
import { useClarityRecording, useViewComponent } from 'hooks';
import { NotFoundPage } from 'pages/NotFound';

import { useOrderViewModel } from './hooks';

export const OrderPage: React.FC = () => {
  const viewModel = useOrderViewModel();
  const OrderView = useViewComponent();
  const LoaderView = useViewComponent(SciPage.PaymentLoading);

  const order = useMemo(
    () => ('order' in viewModel ? viewModel.order : undefined),
    [viewModel],
  );

  useClarityRecording({ orderId: order?.id, status: order?.status });

  if (viewModel.isLoading) {
    return <LoaderView />;
  }

  if (viewModel.authenticationFailed) {
    return <NotFoundPage />;
  }

  return (
    <OrderContext.Provider value={viewModel}>
      <OrderView />
    </OrderContext.Provider>
  );
};
